/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import { showFeedback, dismissFeedback, logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
function handleDefault(state, action) {
    if (action.meta && action.meta.user) {
        return {
            ...state,
            feedback: null
        };
    }
    // for the moment, all actions are removing application feedback.
    // this may not be tenable in the long run.
    return {
        ...state
    };
}
const reducer = createReducer(InitialState.cmx, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.cmx
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.cmx
        }));
    builder.addCase(showFeedback.type, (state, action)=>({
            ...state,
            feedback: action.payload
        }));
    builder.addCase(dismissFeedback.type, (state)=>({
            ...state,
            feedback: null
        }));
    builder.addDefaultCase(handleDefault);
});
export default reducer;
